import React, { FC } from 'react';
import { Container } from '../../components/base/grid';
import Breadcrumbs from '../../components/breadcrumbs';
import SplitHero from '../../components/hero/splitHero';
import HomeDeliveryComponent from '../../components/homeDelivery';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';
import { ContentSectionsMapper } from '../../pages/contentSite/contentSectionsMapper';
import * as StyledHomeDelivery from './homeDelivery.styles';

interface Props {
	page: IPageViewModel;
}

const HomeDelivery: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			{page.Values.HeroImage && page.Values.HeroContent.length > 0 && (
				<SplitHero
					pageId={page.Id}
					title={page.Values.HeroTitle || page.Name}
					content={page.Values.HeroContent}
					button={page.Values.HeroButton}
					image={page.Values.HeroImage}
				/>
			)}

			{page.Values.ContentSections &&
				page.Values.ContentSections.length > 0 &&
				page.Values.ContentSections.map((item, index) => (
					<StyledHomeDelivery.Wrapper key={index}>{ContentSectionsMapper(item)}</StyledHomeDelivery.Wrapper>
				))}
			<HomeDeliveryComponent />
		</Container>
	);
};

export default pageWrapper(HomeDelivery);
